import { createContext } from 'react';
import { UserCreditDetails, UserDetails, UserGeolocation } from '../../types/userTypes';

export type UserContextProps = {
	userDetails: UserDetails;
	getCurrentSession: Function;
	getUserAddress: Function;
	handleSignOut: Function;
	messageSessionExpired: string;
	isSessionExpired: boolean;
	userGeolocation: UserGeolocation;
	createUserAddress: Function;
	createBillingAddress: Function;
	createShippingAddress: Function;
	updateUserData: Function;
	uploadAvatar: Function;
	userCredit: UserCreditDetails;
	getUserCredit: Function;
	addUserCredit: Function;
	updateUserCredit: Function;
	getMagicLink: Function;
};

const UserContext = createContext({} as UserContextProps);

export default UserContext;
